import { Image, Text, View } from "@react-pdf/renderer";

import { styles } from "../../Tables";

export const TableRowOtpadEvdListaDefinisanihTacakaHeader: React.FC<{
  datum: string;
  fullname: string;
  potpis: string;
  vrstaOtpada: string;
  kolicina: string;
  primaoc: string;
  potpisPrimaoca: string;
  korektivnaMjera: string;
  napomena: string;
}> = ({
  fullname,
  potpis,
  vrstaOtpada,
  kolicina,
  primaoc,
  datum,
  potpisPrimaoca,
  korektivnaMjera,
  napomena,
}) => (
  <View style={styles.tableRow}>
    <View style={styles.tableCol}>
      <Text>{datum}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{fullname}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{potpis}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{vrstaOtpada}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{kolicina}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{primaoc}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{potpisPrimaoca}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{korektivnaMjera}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{napomena}</Text>
    </View>
  </View>
);

export const TableRowOtpadEvdListaDefinisanihTacaka: React.FC<{
  datum: string;
  fullname: string;
  potpis: string;
  vrstaOtpada: string;
  kolicina: string;
  jedinicaMjere: string;
  primaoc: string;
  potpisPrimaoca: string;
  korektivnaMjera: string;
  napomena: string;
}> = ({
  datum,
  fullname,
  potpis,
  vrstaOtpada,
  kolicina,
  jedinicaMjere,
  primaoc,
  potpisPrimaoca,
  korektivnaMjera,
  napomena,
}) => (
  <View style={styles.tableRow} wrap={false}>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{datum}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{fullname}</Text>
    </View>
    <View style={styles.tableCol}>
      {potpis && (
        <Image style={[styles.tableCell, styles.signatureImage]} src={potpis} />
      )}
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{vrstaOtpada}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{kolicina + " " + jedinicaMjere}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{primaoc}</Text>
    </View>
    <View style={styles.tableCol}>
      {potpis && (
        <Image
          style={[styles.tableCell, styles.signatureImage]}
          src={potpisPrimaoca}
        />
      )}
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{korektivnaMjera}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{napomena}</Text>
    </View>
  </View>
);
